import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import "./OnionPage.css"; // Include styling here or in a separate file
const modalStyles = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};


const modalContentStyles = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '5px',
  textAlign: 'center',
};
export const EnquiryForm = ({ onClose }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const enquiryform = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    // Prevents page reload on form submission
    setIsModalVisible(true); // Show t

    emailjs
      .sendForm("service_be5k1s1", "template_618ra1q", enquiryform.current, {
        publicKey: "QSz0QsTM68Bd5HTY3",
      })
      .then(
        () => {
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };
  const closeModal = () => {
    setIsModalVisible(false);
  };

  // Close the popup
  const closePopup = () => {
    setIsPopupVisible(false);
  };
  return (
    <>
      <div style={overlayStyle}>
        <div style={formStyle}>
          <h2>Enquiry Form</h2>
          <form onSubmit={sendEmail} ref={enquiryform}>
            <div className="enquiry-unitquant">
              <span>
                <label>Quantity:</label>

                <input
                  type="text"
                  id="quantity_unit"
                  className="quantity_unit"
                  name="from_quantity"
                  placeholder="Quantity"
                />
              </span>
              <span>
                <label>Measurement Units:</label>
                <input
                  type="text"
                  id="kilogram_unit"
                  name="from_kilogram"
                  className="kilogram_unit"
                  placeholder="Kilogram"
                />
              </span>
            </div>
            <div className="enquiry-form-input">
            <label>Name:</label>
            <input name="from_name" type="text" required />
            </div>
            <div className="enquiry-form-input">
            <label>Email:</label>
            <input name="from_email" type="email" required />
            </div>
            <div className="enquiry-form-input">
            <label>Mobile:</label>
            <input name = "from_mobile"type="text" required />
            </div>
            <button type="submit" className="submit-btn">
              Submit
            </button>
            <button type="button" className="submit-btn" onClick={onClose}>
              Close
            </button>
          </form>
          {isPopupVisible && (
            <div className="enquiry-popup">
              <div className="enquiry-popup-content">
                <h2>Form Submitted Successfully!</h2>
                <p>Thank you for submitting the form.</p>
                <button className="submit-btn" onClick={closePopup}>
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      {isModalVisible && (
        <div style={modalStyles}>
          <div style={modalContentStyles}>
            <h2>Success!</h2>
            <p>Your form has been submitted successfully.</p>
            <button className="success" onClick={closeModal}>Close</button>
          </div>
        </div>
      )}
    </>
  );
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",

  justifyContent: "center",
  alignItems: "center",
};

const formStyle = {
  backgroundColor: "white",
  padding: "15px",
  position: "absolute",
  borderRadius: "8px",
  maxWidth: "350px",
  width: "100%",
  color: "black",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
};


